import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import styles from './AuthDropdownMenu.styles';
import NewProfilePlaceholderIcon from 'components/svg/NewProfilePlaceholder';
import Chevron from 'components/svg/Chevron';
import classNames from 'classnames';
import Favourite from 'components/svg/Favourite';
import EditProfile from 'components/svg/EditProfile';
import Logout from 'components/svg/Logout';
import Button from 'components/Button';
import NavigationLink from 'components/NavigationLink';

interface AuthDropdownMenuProps {
  profileDetails: () => void;
  firstName?: string;
}

const useStyles = createUseStyles(styles, { name: 'DropdownMenu' });
const AuthDropdownMenu = ({ profileDetails, firstName }: AuthDropdownMenuProps): JSX.Element => {
  const classes = useStyles();
  const [hideDropdownContent, setHideDropdownContent] = useState(true);
  const profileButtonText = firstName ? firstName : 'Mijn profiel';

  const {
    gigya: {
      accounts: { logout },
    },
  } = window;

  const showDropdownContent = () => {
    if (hideDropdownContent) {
      setHideDropdownContent(false);
    } else {
      setHideDropdownContent(true);
    }
  };

  return (
    <div className={classes.dropdown} onClick={showDropdownContent} data-testid="default-header-dropdown">
      <div className={classNames(classes.dropdownHeader, hideDropdownContent ? '' : classes.dropdownHeaderOpen)}>
        <NewProfilePlaceholderIcon
          className={classes.profileIcon}
          data-testid="default-header-profile-thumbnail-placeholder"
        />
        <Button
          className={classes.dropdownBtn}
          text={profileButtonText}
          type="button"
          data-testid="auth-dropdown-btn"
        />
        <Chevron className={classNames(classes.chevron, hideDropdownContent ? '' : classes.turnChevron)} />
      </div>
      <div
        className={hideDropdownContent ? classes.dropdownContentHide : classes.dropdownContent}
        data-testid="default-header-dropdown-content"
      >
        <div className={classes.dropdownItem}>
          <NavigationLink pageUrl="/mijn-juke" title="Favorieten" className={classes.navLink}>
            <Button
              className={classes.link}
              text="Favorieten"
              data-testid="favourite-btn"
              type="button"
              icon={<Favourite />}
              iconClassName={classes.favouriteIcon}
            />
          </NavigationLink>
        </div>
        <div className={classes.dropdownItem}>
          <Button
            className={classes.dropdownButtons}
            onClick={profileDetails}
            text="Profiel beheren"
            type="button"
            data-testid="profile-details-btn"
            icon={<EditProfile />}
            iconClassName={classes.editProfileIcon}
          />
        </div>
        <div className={classes.dropdownItem}>
          <Button
            className={classes.dropdownButtons}
            onClick={logout}
            text="Uitloggen"
            type="button"
            data-testid="logout-btn"
            icon={<Logout />}
            iconClassName={classes.logoutIcon}
          />
        </div>
      </div>
    </div>
  );
};
export default AuthDropdownMenu;
